{
  "email-phone-confirmation-pin-dialog": {
    "buttons": {
      "resend": "Erneut senden",
      "submit": "Einreichen"
    },
    "text": {
      "email-confirmation": "E-Mail-Bestätigung",
      "enter-to-confirm-email": "Bitte geben Sie den PIN-Code ein, um Ihre E-Mail zu bestätigen",
      "enter-to-confirm-phone": "Bitte geben Sie den PIN-Code ein, um Ihre Telefonnummer zu bestätigen",
      "in-second": "in {{seconds}} s",
      "phone-confirmation": "Bestätigung der Telefonnummer",
      "pin-sent-to-email": "Der PIN-Code wird an Ihre E-Mail geschickt",
      "pin-sent-to-phone": "Der PIN-Code wird an Ihre Telefonnummer gesendet",
      "update-success": "Erfolgreich aktualisiert!"
    }
  }
}
